export default {
  FlowClassRule: '流量分类规则',
  SpeedLimitRule: '限速配置',
  RelationErr: '关联失败',
  GatewayMoreThen10: (names: string) => `网关 ${names} 关联的策略数量已达上限,继续关联将剔除以上网关继续提交。`,
  ContinueRelation: '继续关联'
}